import BaseModelAPI from '../BaseModelAPI';

export default class Repacking extends BaseModelAPI {
	static entity = 'repacking';
	static entityName = 'repacking';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.repackingNo = '';
			this.deliveryInstructionId = '';
			this.deliveryInstruction = {};
			this.repackDate = '';
			this.deliveryDate = '';
			this.repackStatusId = '';
			this.repackStatus = {};
			this.repackById = '';
			this.repackBy = {};
			this.startDate = '';
			this.finishDate = '';
			this.poNoCustomer = '';
			this.repackingDetail = []
			this.repackingControlCard = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async getPartList(this_, qrCode, repackingId) {
        
        let params = "?qrCode=" + qrCode;
        if(repackingId != null && repackingId != undefined) {
			params = params + '&id=' + repackingId;
		}
        
        return this_.$http.get(`${this.entityName}/getunfinisheddatas` + params)
        .then(response => {
            if (response != null) {
                return response.data;
            }
            return response;
        })
        .catch(function(error){
            this_.$store.dispatch('addErrorMessageGlobal', error);
            throw error;
        });
    }

	static async getDeliveryOrderList(this_, qrCode, partId, repackingId) {
        
        let params = "?qrCode=" + qrCode;
        if(repackingId != null && repackingId != undefined) {
			params = params + '&id=' + repackingId;
		}
        
        return this_.$http.get(`${this.entityName}/getdeliveryorders/${partId}/` + params)
        .then(response => {
            if (response != null) {
                return response.data;
            }
            return response;
        })
        .catch(function(error){
            this_.$store.dispatch('addErrorMessageGlobal', error);
            throw error;
        });
    }

	static async confirmDelivery(this_, repackingDetailId) {
		return this_.$http.post(`${this.entityName}/ConfirmRepacking/${repackingDetail}`)
        .then(response => {
            return response;
        })
        .catch(function(error){
            this_.$store.dispatch('addErrorMessageGlobal', error);
            throw error;
        });
	}
}